module.exports = __webpack_public_path__ + "static/media/analysis4.49c55fbb.png";